"use strict";

function App() {
  if (typeof window.jQuery !== 'undefined') {
    window.$ = window.jQuery;
  }
  var header = document.querySelector('.js-header');
  var burger = document.querySelector('.js-burger');
  function initHeader() {
    if (!header) return;
    var onScroll = function onScroll() {
      if (window.scrollY > header.offsetHeight) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed');
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
  }
  function initBurger() {
    if (!burger) return;
    burger.addEventListener('click', function () {
      document.body.classList.toggle('menu-open');
    });
    document.querySelectorAll('.menu-item-has-children').forEach(function (item) {
      var link = item.querySelector(':scope > a');
      if (!link) return;
      var toggle = item.querySelector(':scope > .submenu-toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'submenu-toggle';
        toggle.setAttribute('aria-label', 'Toggle submenu');
        toggle.setAttribute('aria-expanded', 'false');
        link.after(toggle);
      }
      toggle.addEventListener('click', function (event) {
        if (window.innerWidth > 992) return;
        event.preventDefault();
        event.stopPropagation();
        var isOpen = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }
  function initMainSlider() {
    if (typeof window.$ === 'undefined' || !window.$.fn.slick) return;
    var $slider = $('.js-main-slider');
    if (!$slider.length) return;
    var $nav = $('.main-slider__nav');
    var $prev = $('.js-main-slider-prev');
    var $next = $('.js-main-slider-next');
    function getSlidesToShow(slick) {
      return slick.options.slidesToShow || 1;
    }
    function updateMainSlider(slick) {
      var slidesToShow = getSlidesToShow(slick);
      var maxSlide = Math.max(0, slick.slideCount - slidesToShow);
      var allVisible = slick.slideCount <= slidesToShow;
      $nav.toggleClass('is-hidden', allVisible);
      $prev.prop('disabled', slick.currentSlide <= 0);
      $next.prop('disabled', slick.currentSlide >= maxSlide);
    }
    $prev.on('click', function () {
      $slider.slick('slickPrev');
    });
    $next.on('click', function () {
      $slider.slick('slickNext');
    });
    $slider.on('init reInit breakpoint afterChange', function (event, slick) {
      updateMainSlider(slick);
    });
    $slider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      arrows: false,
      dots: false,
      swipeToSlide: true,
      edgeFriction: 0.2,
      responsive: [{
        breakpoint: 1440,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.15
        }
      }]
    });
    updateMainSlider($slider.slick('getSlick'));
  }
  function initBleedSlider() {
    if (typeof window.$ === 'undefined' || !window.$.fn.slick) return;
    var $sliders = $('.js-slider');
    if (!$sliders.length) return;
    $sliders.each(function () {
      var $slider = $(this);
      var $section = $slider.closest('.slider__section');
      var $nav = $slider.closest('.slider__content').find('.slider__nav');
      var $prev = $nav.find('.js-slider-prev');
      var $next = $nav.find('.js-slider-next');
      var isContained = $section.hasClass('slider__section--contained');
      function getSlidesToShow(slick) {
        return slick.options.slidesToShow || 1;
      }
      function updateBleedSlider(slick) {
        var slidesToShow = getSlidesToShow(slick);
        var maxSlide = isContained ? Math.max(0, slick.slideCount - slidesToShow) : Math.max(0, slick.slideCount - 1);
        var allVisible = isContained && slick.slideCount <= slidesToShow;
        $nav.toggleClass('is-hidden', allVisible);
        $prev.prop('disabled', slick.currentSlide <= 0);
        $next.prop('disabled', slick.currentSlide >= maxSlide);
      }
      $prev.on('click', function () {
        $slider.slick('slickPrev');
      });
      $next.on('click', function () {
        $slider.slick('slickNext');
      });
      $slider.on('init reInit breakpoint afterChange', function (event, slick) {
        updateBleedSlider(slick);
      });
      if (isContained) {
        $slider.slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: false,
          dots: false,
          swipeToSlide: true,
          edgeFriction: 0.2,
          responsive: [{
            breakpoint: 1800,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.15
            }
          }]
        });
      } else {
        $slider.slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: false,
          dots: false,
          swipeToSlide: true,
          edgeFriction: 0.2
        });
      }
      updateBleedSlider($slider.slick('getSlick'));
    });
  }
  function initCopyright() {
    document.querySelectorAll('.js-copyright').forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });
  }
  initHeader();
  initBurger();
  initMainSlider();
  initBleedSlider();
  initCopyright();
}
App();